module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/grand_jury__03-1b4e4c114720f36982e6b3a2f488a782.jpg";